import { axios, Response } from '../index'

export interface Body {
  identifier: string
  macroAreaName: string
  macroAreaBodyView: string
  posX: number
  posY: number
}

const createMacroArea = (request: Body): Response<null> => {
  return axios.post(`/v1/macro-areas`, request)
}

export default createMacroArea
